import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectIsUserAuthenticated } from 'features/auth/selectors'

import { Spinner } from 'components/Spinner'

import './PageLoading.scss'

const b = block('page-loading')

const PageLoading: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  return isLoading ? (
    <div className={b({ auth: isAuth })}>
      <Spinner isLoading />
    </div>
  ) : null
}

export default PageLoading
